import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, Container, Grid, TextField, Typography} from '@mui/material';
import {styled} from '@mui/system';
import {log} from "three/src/nodes/math/MathNode";

const CustomButton = styled(Button)(({theme, val}) => ({
    width: "50px",
    backgroundColor:
        !isNaN(val) || val === "." || val === "0"
            ? "#e0e0e0" // Light grey for numbers and decimal
            : "#3B8BEC", // Indigo for operators
    '&:hover': {
        backgroundColor:
            !isNaN(val) || val === "." || val === "0"
                ? "#aeaeae" // Darker grey for numbers and decimal on hover
                : "#3b8becf0", // Brighter indigo for operators on hover
    },
    color: !isNaN(val) || val === "." || val === "0" ? "rgba(0, 0, 0, 0.87)" : "#fff", // Black text for numbers and decimals, white for operators
}));

const Calculator = ({input, setInput, calculate, submit, inputRef}) => {
    const char = ["1", "2", "3", "+", "←", "4", "5", "6", "-", "ОК", "7", "8", "9", "*", "=", "C", "0", ".", "/",]

    const appendValue = (val) => {
        if (![...char, ","].includes(val) || val === "C") return

        const oldInput = input === "Error" ? "" : input
        if (oldInput === "" && ["+", "*", "/", ".", ","].includes(val)) {
            setInput(val === "," ? "0." : "0" + val);
        } else {
            setInput(val === "," ? oldInput + "." : oldInput + val);
        }
        inputRef.current.focus()
    };

    const clear = (all) => {
        if (all || input === "Error") {
            setInput('');
        } else {

            let newString = input.slice(0, -1)
            setInput(newString);
        }
        inputRef.current.focus()
    };

    return (
        <Container maxWidth="xs">
            <TextField
                inputRef={inputRef}
                autoFocus
                fullWidth
                variant="outlined"
                margin="normal"
                value={input}
                onKeyDown={(e) => e.key === "Backspace" ? clear() : e.key === "=" ? calculate() : e.key === "Enter" ? submit() : appendValue(e.key)}
                sx={{
                    '& label.Mui-focused': {
                        color: '#1976d2',
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor: '#1976d2',
                    },
                    '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                        },
                        color: input === "Error" ? "red" : "black",
                    },
                }}
            />
            <Box sx={{
                display: "grid",
                gridTemplateAreas: `                               
                                    "news1 news2 news3 news4 news14"
                                    "news6 news7 news8 news9 news19"
                                    "news11 news12 news13  news15 news5"
                                    "news16 news17 news18  news15 news10"`,
                gap: "5px"
            }}>

                {char.map((val, i) => (
                    <Box key={val} sx={{display: "grid", gridArea: `news${i + 1}`,}}>
                        <CustomButton
                            variant="contained"
                            fullWidth
                            onClick={() => val === "=" ? calculate() : val === "C" ? clear(true) : val === "←" ? clear() : val === "ОК" ? submit() : appendValue(val)}
                            val={val}
                        >
                            {val}
                        </CustomButton>
                    </Box>

                ))}
            </Box>
        </Container>
    );
};

export default Calculator;